/**
* Created by vouill on 5/12/18.
*/

<template>
  <div :class="['modal', {'is-active': isActive}]">
    <div 
      class="modal-background" 
      @click="$router.push('/')"/>
    <div class="modal-card">
      <section class="modal-card-body">
        <div class="content">
          <h3>Email envoyé !</h3>
          <p>
            Verifiez votre boite de réception, vous devriez avoir reçu un email pour réinitialiser votre mot de passe !
          </p>
        </div>
      </section>
    </div>
  </div>
</template>

<style scoped>
a {
  text-decoration: none;
}
</style>

<script>
export default {
  name: "SuccessModal",
  props: { isActive: Boolean },
  components: {},
  data() {
    return {};
  }
};
</script>
